import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'
import configurationShape from '../../../configuration/shapes'
import ThemeFont from './ThemeFont'
//import * as font from '../../../assets/fonts/index'

const ThemeWrapper = props => {
  const { children, configuration } = props
  const { theme } = configuration

  const mediaUrl = () => {
    if (window.location.hostname.indexOf('openflex.eu') !== -1) {
      return 'https://media.openflex.eu/'
    }
    if (window.location.hostname.indexOf('openflex-preprod.eu') !== -1) {
      return 'https://media.openflex-preprod.eu/'
    }
    if (
      window.location.hostname.indexOf('192.168.2.228') !== -1 ||
      window.location.hostname.indexOf('localhost') !== -1
    ) {
      return 'https://media.openflex-preprod.eu/'
    }
    return 'https://media.openflex-preprod.eu/'
  }

  const renderFontFace = () => {
    let fontFace = ''
    if (theme.fontFamily) {
      Object.values(theme.fontFamily).forEach(x => {
        fontFace += ` @font-face {
              font-family: '${x.name}';
              font-style: normal;
              src: local('${x.name}'), local('${x.name}'),
              url(${mediaUrl()}${x.url}2) format('woff2'),
              url(${mediaUrl()}${x.url}) format('woff');
            }`
      })
    }
    return fontFace
  }

  useEffect(() => {
    if (theme.fontFamily) {
      const $style = document.createElement('style')
      document.head.appendChild($style)
      const fontFace = renderFontFace()
      $style.innerHTML = `${fontFace});}`
    }
  }, [theme.fontFamily])

  return (
    <>
      <ThemeFont theme={theme} />
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </>
  )
}

ThemeWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  configuration: configurationShape.isRequired
}

export default ThemeWrapper
